import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { number, oneOfType, string } from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { fetchDocumentForEditingById } from "slices/writing/documents/actions";
import { DATE_VARIANTS, formatDate } from "utils";

const DocumentStaleReloadModal = ({
  documentId,
  originId,
  entityType,
  lastSavedBy,
  lastSavedAt,
}) => {
  const dispatch = useDispatch();

  const onDismiss = () => dispatch(hideModal(modalTypes.DOCUMENT_STALE_RELOAD));

  const onReload = async () => {
    await dispatch(fetchDocumentForEditingById(documentId, originId, entityType));
    onDismiss();
  };

  return (
    <Modal
      data-testid="document-stale-reload-modal"
      onDismiss={onDismiss}
      className="fade-in"
      show
      centered
    >
      <Modal.Header>Newer Version Available</Modal.Header>
      <Modal.Body>
        {lastSavedBy} saved a newer version of this document on{" "}
        {formatDate(lastSavedAt, DATE_VARIANTS.SHORT_TIME)}. Your changes were
        not saved. Reload to see the latest version — your current edits will
        be discarded.
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-test="keepEditingButton"
          variant={NewButtonVariant.l1}
          onClick={onDismiss}
        >
          Keep Editing
        </NewButton>

        <NewButton
          data-test="reloadButton"
          variant={NewButtonVariant.l2}
          onClick={onReload}
        >
          Reload
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

DocumentStaleReloadModal.propTypes = {
  documentId: oneOfType([number, string]).isRequired,
  originId: oneOfType([number, string]).isRequired,
  entityType: string.isRequired,
  lastSavedBy: string,
  lastSavedAt: string,
};

export default DocumentStaleReloadModal;
